import React from 'react';
import './SocialWall.css';

const ImageGallery = ({ images, onImageClick }) => {
  if (!images || images.length === 0) return null;

  const getGridClass = (count) => {
    if (count === 1) return 'gallery-single';
    if (count === 2) return 'gallery-two';
    if (count === 3) return 'gallery-three';
    if (count === 4) return 'gallery-four';
    return 'gallery-multiple';
  };

  return (
    <div className={`image-gallery ${getGridClass(images.length)}`}>
      {images.map((image, index) => (
        <div
          key={index}
          className="gallery-item"
          onClick={() => onImageClick(index)}
        >
          <img
            src={image.url}
            alt={`Image ${index + 1}`}
            loading="lazy"
          />
          {images.length > 4 && index === 3 && (
            <div className="gallery-overlay">
              +{images.length - 4} more
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;

